import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Went live in two weeks and sold on day three. Their product upload team saved us days of work.",
      author: "Riya M.",
      title: "Founder"
    },
    {
      quote: "Site loads faster and conversions climbed 27% in month one.",
      author: "Ajay D.",
      title: "DTC Brand"
    }
  ];

  return (
    <section id="testimonials" className="section" style={{ background: 'white' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '16px'
          }}>
            What Our Clients Say
          </h2>
          <p style={{
            fontSize: '1.25rem',
            color: '#64748b',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Real results from real businesses
          </p>
        </motion.div>

        <div className="grid grid-2">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
              className="card"
              style={{
                textAlign: 'center',
                background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
                border: '1px solid #e2e8f0',
                position: 'relative'
              }}
            >
              <div style={{
                position: 'absolute',
                top: '24px',
                left: '24px',
                color: '#667eea',
                opacity: 0.1
              }}>
                <Quote size={48} />
              </div>

              <p style={{
                fontSize: '1.25rem',
                lineHeight: '1.6',
                color: '#1e293b',
                marginBottom: '24px',
                fontStyle: 'italic',
                position: 'relative',
                zIndex: 1
              }}>
                "{testimonial.quote}"
              </p>

              <div>
                <div style={{
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  color: '#1e293b',
                  marginBottom: '4px'
                }}>
                  — {testimonial.author}
                </div>
                <div style={{
                  fontSize: '1rem',
                  color: '#64748b'
                }}>
                  {testimonial.title}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
